import type { Message, Speed } from './types';

/** One gloss token per 760ms at 1x — 1520ms at 0.5x, 1013ms at 0.75x. */
export const BASE_STEP_MS = 760;

export const SPEEDS: Speed[] = [0.5, 0.75, 1];

export function stepMs(speed: Speed): number {
  return Math.round(BASE_STEP_MS / speed);
}

/** The last N turns of the conversation sent to the interpreter for context. */
export const HISTORY_TURNS = 6;

export const ERROR_COPY = 'The interpreter could not be reached. Try again.';

export const SIMULATED_TRANSCRIPT = 'How do I ask for an Auslan interpreter at the hospital?';

/** Simulated dictation types one word every 170ms. */
export const SIMULATED_WORD_MS = 170;

export const GLOSS_SIZE_LEARNER = 13;
export const GLOSS_SIZE_DEAF_FIRST = 15;

export const GLOSS_SCALE_MIN = 0.85;
export const GLOSS_SCALE_MAX = 1.35;
export const GLOSS_SCALE_STEP = 0.05;

/** The reply already on the stage when the app opens. */
export const SEED_MESSAGE: Message = {
  id: 'seed',
  role: 'ai',
  gloss: [
    { sign: 'HELLO', nmf: 'nod' },
    { sign: 'PRO-2 WELCOME' },
    { sign: 'PRO-2 TYPE ENGLISH' },
    { sign: 'PRO-1 SIGN AUSLAN' },
    { sign: 'PRO-2 WANT-KNOW WHAT' },
    { sign: 'Q', nmf: 'brow furrow, hold' },
  ],
  english: 'Hi, welcome. You type in English and I answer in Auslan. What would you like to know?',
  note: 'Question sign last, brow does the asking — English puts "what" first.',
};

export const GLOSS_KEY: { key: string; meaning: string }[] = [
  { key: 'PRO-1 / PRO-2', meaning: 'I, me / you — pointing, not a word' },
  { key: 'fs-JOHN', meaning: 'Fingerspelled on the two-handed Auslan alphabet' },
  { key: 'SIGN++', meaning: 'Repeat the sign — plural or ongoing' },
  { key: 'CL:', meaning: 'Classifier — the hand becomes the thing' },
  { key: 'Q', meaning: 'Question face: brows, head tilt, hold' },
  { key: 'NMF', meaning: 'Non-manual feature — face and head carry grammar' },
];
